import React from 'react'
import { Spinner } from 'react-bootstrap'

const Loading = () => {
    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
                width: "100%",
                height: "100vh",
                position: "fixed",
                top: 0,
                left: 0,
                background: "#fff",
                zIndex: 999999999
            }}
        >
            <Spinner
                animation="border"
                role="status"
                variant="primary"
                style={{
                    width: "4rem",
                    height: "4rem"
                }}
            />

            <div
                style={{
                    marginTop: "15px",
                    fontSize: "18px",
                    fontWeight: "500",
                    color: "#555"
                }}
            >
                Loading...
            </div>
        </div>
    )
}

export default Loading